/* Replie le bandeau d'annonce des que la page quitte le sommet.

   Lecture directe de la position de defilement plutot qu'une sentinelle
   observee : la sentinelle dependait de la position exacte d'un element de 1px
   dans le flux, qu'un ancetre positionne ou une marge suffisait a decaler sans
   que rien ne le signale.

   Le travail est reporte dans requestAnimationFrame et l'ecouteur est passif :
   au plus un calcul par image, jamais de blocage du defilement. */

(() => {
  const groupe = document.querySelector('.entete-groupe');
  if (!groupe) return;

  // Marge de securite : certains navigateurs restituent un scrollY de 1 ou 2px
  // au chargement. En dessous de ce seuil, on considere qu'on est en haut.
  const SEUIL = 4;

  let planifie = false;

  const majEtat = () => {
    planifie = false;
    const defile = (window.scrollY || document.documentElement.scrollTop) > SEUIL;
    groupe.classList.toggle('entete-groupe--defile', defile);
  };

  const planifier = () => {
    if (planifie) return;
    planifie = true;
    requestAnimationFrame(majEtat);
  };

  window.addEventListener('scroll', planifier, { passive: true });

  // Etat initial : le navigateur peut restaurer une position de defilement
  // au rechargement, l'en-tete doit s'y accorder des la premiere image.
  majEtat();
})();
